<template>
  <v-container fluid style="background-color: white">
    <v-btn class="mb-4 bg-gradient-danger" dark @click="checkAllStudents">
      БҮХ СУРАЛЦАГЧИЙГ ШАЛГАХ
    </v-btn>

    <v-data-table
      :headers="headers"
      :items="$attrs.classStudents"
      class="elevation-1"
      hide-details
      hide-default-footer
      :items-per-page="-1"
    >
      <template v-slot:item.action="{ item }">
        <v-btn color="red" outlined small @click="checkStudent(item)">
          ШАЛГАХ
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      headers: [
        { text: "№", value: "index", sortable: false, width: "2%" },
        { text: "Суралцагч", value: "name" },
        { text: "Регистр", value: "REGISTER" },
        { text: "Үйлдэл", value: "action", sortable: false },
        { text: "Үйлдлийн огноо", value: "date" },
        { text: "Устгах", value: "delete", sortable: false },
      ],
      students: [
        { name: "С.Айгерим", register: "щц13281304", date: "-", delete: "-" },
        { name: "Г.Анан", register: "ме13231213", date: "-", delete: "-" },
        {
          name: "Б.Бат-Ирээдүй",
          register: "тю13271716",
          date: "-",
          delete: "-",
        },
        // Add the rest of your student data here
      ],
    };
  },
  methods: {
    async checkStudent(student) {
      console.log("Checking student:", student.name, student.index);
      var bodyData = {
        inStudentGroupID: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
        inStudentList: [
          {
            person_id: Number(student.PERSON_ID),
            row_number: student.index,
          },
        ],
      };
      var urlLink =
        this.$store.state.domainESISAddress +
        "/svc/api/hub/stdnt/completed/save";

      console.log("urlLink", urlLink);
      console.log("bodyData", bodyData);
      console.log(this.$attrs.tokenData.token);
      await this.writeToESIS(urlLink, bodyData);
      // this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
    },
    async checkAllStudents() {
      var bodyData = {
        studentGroupId: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
        inStudentList: [],
      };
      for (var i = 0; i < this.$attrs.classStudents.length; i++) {
        var ss = this.$attrs.classStudents[i];
        {
          bodyData["inStudentList"].push({
            person_id: Number(ss.PERSON_ID),
            row_number: i + 1,
          });
        }
      }
      var urlLink =
        this.$store.state.domainESISAddress +
        "/svc/api/hub/stdnt/completed/save";

      console.log("writing to... urlLink", urlLink);
      console.log("bodyData", bodyData);
      console.log(this.$attrs.tokenData.token);
      //await this.writeToESIS(urlLink, bodyData);
      // this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
    },
    async writeToESIS(urlLink, bodyData) {
      var startTime = new Date();
      await axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/esisWrite",
          {
            url: urlLink,
            token: this.$attrs.tokenData.token,
            data: bodyData,
          }
        )
        .then((res) => {
          this.loading = false;
          var diff = this.timeDifference(startTime, new Date());
          console.log(
            "RESPONSE from ESIS",
            res,
            res.status == 200,
            res.data.SUCCESS_CODE
          );
          this.saveESISresponse = res;
          this.$swal.fire({
            title: res.data.RESPONSE_MESSAGE,
            text: res.data.RESULT + "<p>" + diff + "</p>",
          });
          // this.showSaveESISResponseDialog = !this.showSaveESISResponseDialog;
        })
        .catch((error) => {
          console.log(this.$attrs.tokenData.token);
          console.log(bodyData);
          console.error("Error:", error);
          this.$swal.fire({
            title: error.code,
            text: error.response.data,
            icon: "error",
          });
          //errorhandling write to firebase
        });
    },
  },
};
</script>
